import { lazyNamed } from 'src/utils/lazyNamed';

export const Campaigns = {
  CampaignsList: lazyNamed(() => import('./containers/CampaignsList'), 'CampaignsList'),
  CampaignOverview: lazyNamed(() => import('./containers/CampaignOverview'), 'CampaignOverview'),
  CampaignHistory: lazyNamed(() => import('./containers/CampaignHistory'), 'CampaignHistory'),
  CampaignCreateForm: lazyNamed(() => import('./containers/CampaignCreateForm'), 'CampaignCreateForm'),
  PositionCreateForm: lazyNamed(() => import('./containers/PositionCreateForm'), 'PositionCreateForm'),
  PositionEditForm: lazyNamed(() => import('./containers/PositionEditForm'), 'PositionEditForm'),
  PositionHistory: lazyNamed(() => import('./containers/PositionHistory'), 'PositionHistory'),
  CampaignSummary: lazyNamed(() => import('./containers/CampaignSummary'), 'CampaignSummary'),
  OrderPreview: lazyNamed(() => import('./containers/OrderPreview'), 'OrderPreview'),
};
